import { createCustomEvent } from "../../../../javascript/shared/helpers"

export default class extends Controller {
  static targets = ["backShift", "today", "forwardShift"]

  connect() {
    this.emitSuccessEvent = this.emitSuccessEvent.bind(this)
    App.Helpers.listenToCustomEvent(document, "day-shift:update-date", (event => {
      this.baseDate = event.detail.date
    }).bind(this))
  }

  shiftBack(event) {
    event && event.preventDefault()
    if (!event.currentTarget.disabled) {
      this.shiftTo(App.DateTime.backStr(this.baseDate, 1, "day"), "back")
    }
  }

  shiftForward(event) {
    event && event.preventDefault()
    if (!event.currentTarget.disabled) {
      this.shiftTo(App.DateTime.forwardStr(this.baseDate, 1, "days"), "forward")
    }
  }

  shiftToday(event) {
    event && event.preventDefault()
    if (!event.currentTarget.disabled) {
      this.shiftTo(App.DateTime.todayStr())
    }
  }

  shiftTo(dateStr, direction) {
    const url = this.urlFor(dateStr, direction)
    App.Helpers.ajaxRequest({
      url,
      successHandler: (response => {
        this.emitSuccessEvent({ ...response, date: dateStr }, direction)
        this.baseDate = dateStr
      }).bind(this)
    })
  }

  urlFor(dateStr, direction) {
    const newDateStr = direction === "forward" ? App.DateTime.forwardStr(dateStr, 7, "days") : dateStr
    return direction ? this.baseURL.replace(this.urlDatePlaceholder, newDateStr) : this.todayURL
  }

  get todayURL() {
    return this.data.get("today-url") || this.urlFor(App.DateTime.todayStr())
  }

  emitSuccessEvent(response, direction) {
    document.dispatchEvent(
      createCustomEvent(this.shiftSuccessEventNameFor(direction), this.element, { direction, response })
    )
  }

  shiftSuccessEventNameFor(direction) {
    return direction ? "day-shift:fetch-success" : "digest-view:fetch-success"
  }

  get urlDatePlaceholder() {
    return this.data.get("url-date-placeholder")
  }

  get baseDate() {
    return this.data.get("base-date")
  }

  get baseURL() {
    return this.data.get("base-url")
  }

  set baseDate(dateStr) {
    this.data.set("base-date", dateStr)
    this.todayIsDisabled = dateStr === App.DateTime.todayStr()
  }

  set todayIsDisabled(isDisabled) {
    this.todayTarget.classList[isDisabled ? "add" : "remove"]("disabled")
  }
}



// WEBPACK FOOTER //
// ./app/components/date_selects/assets/javascript/date-selects-day-shift-controller.js